import { render, staticRenderFns } from "./RefineSearchMultiCheckboxButton.vue?vue&type=template&id=bfef896a&scoped=true&"
import script from "./RefineSearchMultiCheckboxButton.vue?vue&type=script&lang=js&"
export * from "./RefineSearchMultiCheckboxButton.vue?vue&type=script&lang=js&"
import style0 from "./RefineSearchMultiCheckboxButton.vue?vue&type=style&index=0&id=bfef896a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfef896a",
  null
  
)

export default component.exports